// const obj = { name: 'obj' };
// const obj2 = { name: 'obj2' };
// export default { obj, obj2 };

export const QueryType_CheckIn_Index_Test="QueryType_CheckIn_Index_Test";
export const QueryType_CheckIn_Index_1_Event="QueryType_CheckIn_Index_1_Event";
export const QueryType_CheckIn_Index_2_EventMember="QueryType_CheckIn_Index_2_EventMember";
export const QueryType_CheckIn_Index_3_EventMemberJoinInfo="QueryType_CheckIn_Index_3_EventMemberJoinInfo";

export const CheckIn_EventItemType_Open="Open";
export const CheckIn_EventItemType_NeedReg="NeedReg";



export default {


    GetLocalMemberId(){
        debugger // eslint-disable-line
        let value="";
        try {
            value=localStorage.getItem("checkInMemberId");
            // if (value==="") {
            //     value=this.getCookie("checkInMemberId");
            // }
        } catch (e) {
            value=this.getCookie("checkInMemberId");
        }

        return value;
    },
    SetLocalMemberId(memberSystemId){
        // debugger // eslint-disable-line
        try {
            localStorage.setItem("checkInMemberId", memberSystemId);
        } catch (e) {
            console.log("localStorage is fail");
        }

        try {
            this.setCookie_day("checkInMemberId", memberSystemId);
        } catch (e) {
            console.log("cookie is fail");
        }
    },



    setCookie_day(c_name,value) {
        let expireValue=2 * 24 * 60*60;
        this.setCookie(c_name,value,expireValue);
    },
    setCookie(c_name,value,expire) {
        var date=new Date()
        // 這個是cookie有效期，將cookie的有效時間設成當前時間之前就是刪除
        date.setSeconds(date.getSeconds()+expire)
        document.cookie=c_name+ "="+escape(value)+"; expires="+date.toGMTString()
        // console.log(document.cookie)
    },

    /*獲取cookie*/
    getCookie(c_name){
        if (document.cookie.length>0){
            let c_start=document.cookie.indexOf(c_name + "=")
            if (c_start!=-1){
                c_start=c_start + c_name.length+1
                let c_end=document.cookie.indexOf(";",c_start)
                if (c_end==-1) c_end=document.cookie.length
                return unescape(document.cookie.substring(c_start,c_end))
            }
        }
        return ""
    },
}
